<script>
import { mapGetters } from 'vuex'
import { mapFilters } from '@/filters/map-filters.js'

export default {
  methods: {
    setTimeSlot(slot) {
      const selectedSlot = _.find(this.availableTimes[this.productDateKey], (timeSlot) => {
        return timeSlot.Time === slot
      })
      this.$store.commit('products/setSelectedProductActivityQuantityAvailable', selectedSlot.AvailableInventory)
      if (selectedSlot.AvailableInventory > 0) {
        this.$store.commit('products/setProductQuantity', '1')
      } else {
        this.$store.commit('products/setProductQuantity', null)
      }
    },

    ...mapFilters(['removeCurrencyFraction', 'convertToTime']),
  },
  computed: {
    productDateAttribute() {
      return !_.isEmpty(this.dateAttributes) ? this.dateAttributes[0] : null
    },

    productDateKey() {
      let dateKey = null
      if (this.productDate) {
        dateKey = `${this.productDate.getFullYear()}-${_.padStart(
          this.productDate.getMonth() + 1,
          2,
          '0'
        )}-${_.padStart(this.productDate.getDate(), 2, '0')}`
      }

      return dateKey
    },

    availableTimesForDate() {
      let availableTimes = []
      if (this.productDateKey && this.availableTimes) {
        const times = this.availableTimes[this.productDateKey]
        if (times) {
          availableTimes = times.map((timeValue) => {
            const inventoryText =
              timeValue.AvailableInventory > 0 ? `${timeValue.AvailableInventory} available` : 'SOLD OUT'
            return {
              value: timeValue.Time,
              name: `${this.convertToTime(timeValue.Time)} (${inventoryText})`,
            }
          })
        }
      }

      return availableTimes
    },

    ...mapGetters({
      availableTimes: 'products/selectedProductActivityTimes',
      product: 'products/selectedProduct',
      productHeaderCode: 'products/selectedProductHeaderCode',
      productDate: 'products/selectedProductDate',
    }),
  },
  render() {
    return this.$scopedSlots.default({
      availableTimes: this.availableTimesForDate,
      selectedDate: this.productDate,
      setTimeSlot: this.setTimeSlot,
    })
  },
}
</script>
